<div class="col-12 widget-wrapper align-self-center">
  <div class="wallet-box">
    <!--User Details and Round timer -->
    <app-round-user-details *ngIf="isPresalestarted" [liveCounter]="liveCounter"
      [raisedInfo]="raisedInfo"></app-round-user-details>
    <!-- <app-widget-coming-soon *ngIf="!isPresalestarted" [liveCounter]="preliveCounter"></app-widget-coming-soon> -->
    <!--User Details and Round timer -->

    <!-- Transaction Area -->
    <div class="swapArea" *ngIf="isPresalestarted"
      [ngClass]="{ cover: status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending }">
      <p class="text-center mb-3 font-14 dashTitle"
        [ngClass]="{ shimmer: !usdRaised || usdRaised <= 0, 'mt-3': !walletAddress }">1 {{ tokenName }} = ${{ salePrice
        }}</p>

      @if (walletAddress && dataLoaded) {
      <!-- Two-way binding keeps parent isNative/isWert in sync when swap mutates them internally (e.g. toggleWert) -->
      <app-swap [(isNative)]="isNative" [(isWert)]="isWert" #swap></app-swap>
      }

      @if (!walletAddress) {
      <div class="d-flex align-items-center justify-content-center gap-2 mt-4">
        <button class="btn btn-primary w-100" (click)="isWert = true; connectModal('Widget-Card')">
          <span>{{ 'widget.buy_with_card' | translate }}</span>
        </button>
        <button class="btn btn-primary w-100 px-2" (click)="isWert = false; connectModal('Widget-Crypto')">
          <span>{{ 'widget.buy_with_crypto' | translate }}</span>
        </button>
      </div>
      }

      <div class="mt-3">
        @if (!walletAddress) {
        <div class="my-2 w-100 d-flex justify-content-center align-items-center cursor-pointer"
          (click)="openBestWallet()">
          <span class="d-inline-block text-white d-flex justify-content-center font-14 text-decoration-underline">{{
            'widget.no_wallet_click_here' | translate }}</span>
        </div>
        }

        <!--- dont have wallet-->

        <p class="font-14 text-center fw-regular mb-0 d-flex align-items-center justify-content-center">
          <span class="me-2">{{ 'widget.powered_by' | translate }}</span>
          <a href="https://web3paymentsolutions.io" target="_blank" (click)="trackPartnerClick()">
            <img src="/assets/images/svg-icons/W3P_White.svg" alt="web3paymentsolutions Logo" loading="eager"
              class="poweredByIcon text-tertiary" />
          </a>
        </p>
      </div>
    </div>
    <!-- Transaction Area -->
  </div>
</div>